import { render, staticRenderFns } from "./UpdateQuestion.vue?vue&type=template&id=59dfd050"
import script from "./UpdateQuestion.vue?vue&type=script&lang=js"
export * from "./UpdateQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports